import { gql, useQuery } from '@apollo/client';

const getConfigSwitch = gql`
  query ConfigFlagsXpCard {
    config {
      enableXpProductCard: genericType(name: "enableXpProductCard")
    }
  }
`;

const useProductCardSwitch = () => {
  const { data: switchData } = useQuery(getConfigSwitch);

  return switchData?.config?.enableXpProductCard?.value;
};

export default useProductCardSwitch;
